import styles from "./RecentChargesLayout.module.scss";
import { NavLink } from "react-router-dom";
import { Outlet } from "react-router";
import { useTranslation } from "react-i18next";

const RecentChargesLayout = () => {
  const { t } = useTranslation();

  return (
    <div className={styles.container}>
      <div className={styles.top}>
        <NavLink
          to={"/settings/recent-charges"}
          end
          className={({ isActive }) => (isActive ? `${styles.link} ${styles.active}` : styles.link)}
        >
          {t("RecentCharges")}
        </NavLink>
        <NavLink
          to={"/settings/recent-charges/purchase-history"}
          className={({ isActive }) => (isActive ? `${styles.link} ${styles.active}` : styles.link)}
        >
          {t("PurchaseHistory")}
        </NavLink>
      </div>
      <Outlet />
    </div>
  );
};

export default RecentChargesLayout;
